import api from "../../lib/api";
import { toArr, clientFilter } from "./_base";

// Mapped to CITIDAN auth + users endpoints.
export const User = {
  async me() {
    const { data } = await api.get("/auth/me");
    // Base44 screens read `full_name`; CITIDAN returns `name`. Provide both.
    return { ...data, full_name: data.full_name || data.name || data.email || "" };
  },
  async list() {
    const { data } = await api.get("/users");
    return toArr(data);
  },
  async filter(query) {
    const { data } = await api.get("/users");
    return clientFilter(toArr(data), query);
  },
  // CITIDAN has no self-profile-update endpoint; resolve with current profile (no-op).
  async updateMyUserData() {
    const { data } = await api.get("/auth/me");
    return data;
  },
};
